import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from "@angular/common/http";
import { inject } from "@angular/core";
import { CUSTOM_HTTP_INTERCEPTOR_REDIRECT_TOKEN } from "./custom-http-interceptor-redirect-token";
import { catchError, throwError } from "rxjs";

/**
 * Performs a redirect action to the injected url in case of the error response with code: {@link HttpStatusCode#Unauthorized}
 *
 * @author Mateusz Warzyc
 * @param req request
 * @param next request handler
 */
export const customHttpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const redirectUrl = inject(CUSTOM_HTTP_INTERCEPTOR_REDIRECT_TOKEN);

  return next(req).pipe(
    catchError((response: HttpErrorResponse) => {
      if (HttpStatusCode.Unauthorized === response.status) {
        window.location.href = redirectUrl;
      }
      return throwError(() => response);
    })
  );
};
